import {
  Avatar,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import api from "services/api";
import SearchIcon from "@mui/icons-material/Search";
import { Page } from "v2/components";
import { ChevronRight } from "@mui/icons-material";
import { StyledInputLabel, StyledSelect, StyledTextField, Subtitle, Title } from "./styled";
import { useAuth } from "contexts/auth";

interface IResponse {
  buyer: {
    id: string;
    corporateName: string;
    federalTaxId: string;
  };
  workspaces: {
    id: string;
    name: string;
    layoutQuantity: number;
    activityQuantity: number;
    connectorQuantity: number;
  }[];
  link: string;
}


function maskCNPJ(cnpj: string): string {
  // Remove tudo que não for dígito
  const digits = cnpj.replace(/\D/g, '');

  // Aplica a máscara: 00.000.000/0000-00
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .slice(0, 18); // Garante que não passe do tamanho do CNPJ
}

function getInitials(corporateName: string) {
  const firstLetter = corporateName?.split(" ")?.[0]?.split("")?.[0]?.toUpperCase();
  const secondLetter = corporateName?.split(" ")?.[1]?.split("")?.[0]?.toUpperCase();

  if (!firstLetter && !secondLetter) return "AB";

  if (!secondLetter) return firstLetter;

  if (!firstLetter) return secondLetter;

  return `${firstLetter}${secondLetter}`;
}


export function WorkspaceListBuyerSeller() {
  const { sellerId, buyerId } = useParams() as {
    sellerId: string;
    buyerId: string;
  };
  const history = useHistory();
  const user = useAuth();
  const isSeller = user.user?.isSeller ?? false;

  const [search, setSearch] = useState("");

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["workspacesBuyerSeller", sellerId, buyerId],
    queryFn: () => api.get<{ data: IResponse }>(`/v2/organizations/contracts/${sellerId}/${buyerId}`),
    select: (data) => data.data.data,
  });

  return (
    <Page title="Contratos" backRoute={data?.link}>
      <Page.Tab name="AA">
        <>
          {!isFetched && isFetching && <div>Loading...</div>}
          {!isFetched && isError && <div>Error...</div>}
          {data && (
            <>
              <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                <div style={{display: "flex", flexDirection: "row", gap: "8px", marginBottom: "10px"}}>
                  <Avatar alt="Avatar" variant="circular" style={{ width: "40px" }}>{getInitials(data.buyer.corporateName)}</Avatar>
                  <div style={{display: "flex", flexDirection: "column"}}>
                    <Title>{data.buyer.corporateName}</Title>
                    <Subtitle>{maskCNPJ(data.buyer.federalTaxId)}</Subtitle>
                  </div>
                </div>
                {/* {isSeller || !isSeller && ( */}
                  <Button
                    variant="contained"
                    style={{
                      paddingTop: "0.25rem",
                      paddingBottom: "0.25rem",
                      paddingLeft: "1rem",
                      paddingRight: "1rem",
                      borderRadius: "0.375rem",
                      height: "2.5rem",
                      fontSize: "0.875rem",
                      lineHeight: "1.25rem",
                      fontWeight: 600,
                      // width: "130px",
                    }}
                    onClick={() => history.push(`/v2/workspaces/${data.buyer.id}/create`)}
                  >
                    Adicionar um contrato
                  </Button>
                {/* )} */}
              </div>
              <StyledTextField
                value={search}
                placeholder="Digite para pesquisar"
                label="Nome do contrato"
                onChange={(e) => setSearch(e.target.value.toLowerCase())}
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        color="action"
                        style={{ width: "24px", aspectRatio: "1" }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
              {/* <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "16px",
                  marginBottom: "20px",
                }}
              >
                <FormControl style={{ width: "230px" }} >
                  <StyledInputLabel id="tipo-supplier">Operadora</StyledInputLabel>
                  <StyledSelect
                    labelId="tipo-supplier"
                    value={selectedSupplier}
                    onChange={(e) => setSelectedSupplier(e.target.value as string)}
                    style={{ height: "55.3px", marginBottom: "2.7px" }}
                  >
                    {layouts.map(layout => <MenuItem key={layout.name} value={layout.name}>{layout.name}</MenuItem>)}
                    <MenuItem value="TODOS">Todos</MenuItem>
                  </StyledSelect>
                </FormControl>
              </div> */}
              <TableContainer
                sx={{
                  "& .MuiTableCell-root": { background: "#FFFFFF !important" },
                }}
              >
                <Table>
                  <TableRow style={{ height: "70px" }}>
                    <TableCell>
                      <span
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: "rgb(111, 111, 120)",
                          fontWeight: "600",
                        }}
                      >
                        Contrato
                      </span>
                    </TableCell>
                    <TableCell>
                      <span
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: "rgb(111, 111, 120)",
                          fontWeight: "600",
                        }}
                      >
                        Atividades
                      </span>
                    </TableCell>
                    <TableCell>
                      <span
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: "rgb(111, 111, 120)",
                          fontWeight: "600",
                        }}
                      >
                        Conectores
                      </span>
                    </TableCell>
                    <TableCell>
                      <span
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: "rgb(111, 111, 120)",
                          fontWeight: "600",
                        }}
                      >
                        Layouts
                      </span>
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  {data.workspaces.map((workspace) => (
                    <>
                    {workspace.name?.split("-")?.at(-1)?.trim() === "Vida" ? (
                      <TableRow key={workspace.id} style={{ height: "70px" }}>
                        <TableCell>{workspace.name}</TableCell>
                        <TableCell>{workspace.activityQuantity ?? 0}</TableCell>
                        <TableCell>{workspace.connectorQuantity ?? 0}</TableCell>
                        <TableCell>{workspace.layoutQuantity ?? 0}</TableCell>
                        <TableCell>
                          {/* {isSeller || !isSeller && ( */}
                            <IconButton
                              size="small"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                history.push(
                                  `/v2/workspaces/${workspace.id}/edit-life`
                                )
                              }
                            >
                              <ChevronRight />
                            </IconButton>
                          {/* )} */}
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow key={workspace.id} style={{ height: "70px" }}>
                        <TableCell>{workspace.name}</TableCell>
                        <TableCell>{workspace.activityQuantity ?? 0}</TableCell>
                        <TableCell>{workspace.connectorQuantity ?? 0}</TableCell>
                        <TableCell>{workspace.layoutQuantity ?? 0}</TableCell>
                        <TableCell>
                          {/* {isSeller || !isSeller && ( */}
                            <IconButton
                              size="small"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                history.push(
                                  `/v2/workspaces/${workspace.id}/edit`
                                )
                              }
                            >
                              <ChevronRight />
                            </IconButton>
                          {/* )} */}
                        </TableCell>
                      </TableRow>
                    )}
                    </>
                  ))}
                </Table>
              </TableContainer>
            </>
          )}
        </>
      </Page.Tab>
    </Page>
  );
}
